export default __webpack_public_path__ + "static/media/spooky_hill_xl2.f6924658.png";